// src/queries/pages/dashboard/registrationApiConfig.js

import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const registrationConfig = {
  /* -------------------------------------------------------------------------- */
  /*                               FETCH OPERATIONS                             */
  /* -------------------------------------------------------------------------- */

  getMyAssignedRegistrations: {
    key: "getMyAssignedRegistrations",
    url: "/api/v1/registrations",
    method: "GET",
    options: {
      ...QUERY_PRESETS.REALTIME,
      refetchOnReconnect: true,
      retry: 2,
      keepPreviousData: true,
      meta: { description: "Fetch all assigned registrations for PMS staff" },
    },
  },

  getPropertyOwnerRegistrations: {
    key: "getPropertyOwnerRegistrations",
    url: "/api/v1/registrations",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.LONG,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 2,
      keepPreviousData: true,
      meta: {
        description: "Fetch all property owner registrations with pagination",
      },
    },
  },

  getPropertyOwnerRegistrationById: {
    key: "getPropertyOwnerRegistrationById",
    url: (params) => `/api/v1/registrations/by-code/${params.uniqueCode || params.id || params}`,
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.LONG,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 2,
      keepPreviousData: true,
      meta: { description: "Fetch property owner registration by ID" },
    },
  },

  getPmsStaffByOrg: {
    key: "getPmsStaffByOrg",
    url: "/api/v1/users/staff",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LONG,
      gcTime: GC_TIME.LONG,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 2,
      meta: { description: "Fetch PMS staff members" },
    },
  },

  assignStaffByPmsAdmin: {
    key: "assignStaffByPmsAdmin",
    url: (data) => `/api/v1/registrations/${data.id}/assign`,
    method: "PATCH",
    options: {
      invalidateKeys: [
        "getPropertyOwnerRegistrations",
        "getPropertyOwnerRegistrationById",
      ],
      meta: { description: "Assign staff to a registration" },
    },
  },

  /* -------------------------------------------------------------------------- */
  /*                            MUTATION OPERATIONS                             */
  /* -------------------------------------------------------------------------- */

  updateRegistration: {
    key: "updateRegistration",
    url: (data) => `/api/v1/registrations/${data.id}/status`,
    method: "PATCH",
    options: {
      invalidateKeys: [
        "getPropertyOwnerRegistrations",
        "getMyAssignedRegistrations",
      ],
      meta: { description: "Update registration status (approve/reject)" },
    },
  },

  createPropertyOwnerRegistration: {
    key: "createPropertyOwnerRegistration",
    url: "/api/v1/registrations",
    method: "POST",
    options: {
      meta: { description: "Create property owner registration successfully" },
    },
  },

  updateRegistrationSubscription: {
    key: "updateRegistrationSubscription",
    url: (data) => `/api/v1/registrations/${data.id}`,
    method: "PATCH",
    options: {
      invalidateKeys: [
        "getPropertyOwnerRegistrations",
        "getPropertyOwnerRegistrationById",
        "getMyAssignedRegistrations",
      ],
      meta: { description: "Update registration subscription information" },
    },
  },

  getServiceRegistrations: {
    key: "getServiceRegistrations",
    url: (params) => `/api/v1/service-registrations/${params.registrationId}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.SHORT,
      refetchOnReconnect: true,
      retry: 2,
      meta: {
        description: "Fetch service registration statuses for a property",
      },
    },
  },
};
